import Divider from "@material-ui/core/Divider";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { Endpoint } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import "./home.scss";

const services = require("./home.json");

export default function Home(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [memonidCard, setMemonidCard] = React.useState("");
  const [memonidCardImage, setMemonidCardImage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const getMemonIDCard = () => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, Endpoint.MEMMON_ID_CARD)
      .then((response) => {
        dispatch(stopLoading);
        setMemonidCardImage(response.data.data.communityid);
        const blob = base64toBlob(response.data.data.communityid);
        const blobUrl = URL.createObjectURL(blob);
        setMemonidCard(blobUrl);
        handleClickOpen();
        // openBase64NewTab(response.data.data.memonid);
      })
      .catch((error) => {
        dispatch(stopLoading);
        console.log(error);
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  function downloadBase64File(contentType, base64Data, fileName) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const openBase64NewTab = (base64Pdf) => {
    var blob = base64toBlob(base64Pdf);
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, "pdfBase64.png");
    } else {
      const blobUrl = URL.createObjectURL(blob);
      // window.open(blobUrl);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "image.png";
      link.click();
    }
  };

  const base64toBlob = (base64Data) => {
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);

      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: "image/png" });
  };

  const handleDownload = async (e) => {
    try {
      // Call this method when you've finished using an object URL to let the browser know not to keep the reference to the file any longer.
      URL.revokeObjectURL(memonidCard);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="dashboard-page p-3 fancyFont">
      <div className="font-36 brand-text-color mt-3 font-medium">
        Congratulations!
      </div>
      <div className="font-36 brand-text-color font-medium">
        You are now connected to Million
      </div>
      <div className="font-36 brand-text-color font-medium">
        Memons around the world!
      </div>
      <div className="font-18  mt-3 text-black-70 font-medium">
        To download{" "}
        <span className={"brand-text-color font-bold"}>MemonID Card </span>
        <button className={"btn custom-button"}>
          <span
            onClick={() => getMemonIDCard()}
            className={"text-black-70 font-bold"}
          >
            Click here!
          </span>
        </button>
      </div>
      <div className="font-18 mt-3 text-black-70 font-bold">
        AND ENTITLED TO THE FOLLOWING SERVICES
      </div>
      <table className={"mt-3 mb-5 col-12"}>
        {services.map((service) => (
          <tr className={"bottom-border"}>
            <th className="p-2">
              <Link to={service.url} className={"link-black"} target="_blank">
                <div
                  className={
                    (service.isTitleBrand
                      ? "brand-text-color"
                      : "text-black-70") + " font-18 font-medium"
                  }
                >
                  {service.title}
                </div>

                <div
                  className={
                    (service.isSubTitleBrand
                      ? "brand-text-color"
                      : "text-black-70") + " font-18 font-medium"
                  }
                >
                  {service.subTitle}
                </div>
              </Link>
            </th>
            <td className="font-16">
              <Link to={service.url} className={"link-black font-medium"}>
                {service.description}
              </Link>
            </td>
          </tr>
        ))}
      </table>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle className={"background-color-head"}>
          <span className={"font-bold font-18"}>Download MemonID</span>
        </DialogTitle>
        <Divider />

        <div className={"p-5"}>
          <Image
            src={`data:image/png;base64,${memonidCardImage}`}
            alt={"MemonID"}
            width={"100%"}
          />
        </div>
        <DialogActions>
          <button
            className={"btn custom-negative-button"}
            onClick={handleClose}
          >
            Cancel
          </button>
          <button className={"btn custom-positive-button"}>
            <a
              className={"link-black text-black-70 font-bold"}
              href={memonidCard}
              download={"MemonID"}
            >
              Download
            </a>
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
